import { Fragment, useEffect, useState, useRef } from "react";
import "./ScheduleView.scss";
import { useDispatch, useSelector } from "react-redux";
import UnifiedControlPlaneService from "../../UnifiedControlPlane.service";
import { getTimeEpochToUTC } from "../Utils/HelperFunctions";
import {
  getListOfOrders,
  getPriorityIcon,
  getStatusDetails,
} from "./CurrentScheduleView";
import {
  ChevronRight,
  EmptyListIcon,
  InfoIcon,
  ScheduleGroundAssignIcon,
  ScheduleOrderAssignIcon,
  SortColumnIcon,
} from "../../assets/icons/Icons";
import {
  setAllowPresimAnalyze,
  setDefaultPredictionData,
  setDefaultPredictionForSatellite,
  setFidelity,
  setScheduleDashboardView,
  setSelectedGroup,
  setSelectedSatellite,
  setShowReviewSchedulePopup,
} from "../../../../store/UnifiedControlPlaneSlice";
import { CircularProgress } from "@mui/material";
import CustomToolTip from "../../../CommonComponents/CustomToolTip";

const SingleScheduleView = ({ mission_id, scenarioId }) => {
  const dispatch = useDispatch();
  const fetchingOrderAssignments = useSelector(
    (state) => state.unifiedControlPlane.fetchingOrderAssignments
  );
  const orderAssignments = useSelector(
    (state) => state.unifiedControlPlane.orderAssignments
  );
  const schedules = useSelector((state) => state.unifiedControlPlane.schedules);
  const previewScheduleId = useSelector(
    (state) => state.unifiedControlPlane.previewScheduleId
  );

  const scenario = useSelector(
    (state) => state.unifiedControlPlane.selectedScenario
  );

  /*** AT-11431 FIX ***/
  // let selectedGroup = useSelector(state => state.unifiedControlPlane.presimData.selectedGroup);
  let satelliteGroup = scenario?.satelliteGroups?.[0];

  const fidelity = useSelector((state) => state.unifiedControlPlane.fidelity);

  const [currentSchedule, setCurrentSchedule] = useState();
  const [showFidelityConfig, setShowFidelityConfig] = useState(false)
  const [showFidelityInfo, setShowFidelityInfo] = useState(false)
  const fidelityConfigRef = useRef(null);
  const toggleButtonRef = useRef(null);

  const filterAssignedSatellites = (satelliteGroup, orderAssignments) => {
    if (!orderAssignments?.length) return satelliteGroup;

    const assignedSatIds = new Set(
      orderAssignments.map((a) => a?.data?.satellite?.id).filter(Boolean)
    );

    const filteredSatellites =
      satelliteGroup?.satellites?.filter((sat) =>
        assignedSatIds.has(sat?.satelliteId)
      ) || [];

    if (filteredSatellites?.length > 0) {
      return {
        ...satelliteGroup,
        satellites: filteredSatellites
      };
    }

    return satelliteGroup;
  };

  const checkPredictionData = () => {
    satelliteGroup = filterAssignedSatellites(satelliteGroup, orderAssignments);
    dispatch(UnifiedControlPlaneService.getPredictionData(
      mission_id,
      scenarioId,
      previewScheduleId,
      /*** AT-11431 FIX ***/
      // scenario.satelliteGroups[0].satellites[0].satelliteId,
      // scenario.satelliteGroups[0].satelliteGroupId
      satelliteGroup?.satellites?.[0]?.satelliteId,
      satelliteGroup?.satelliteGroupId
    ));
  }

  const orderUpdateSuccessCallback = (action) => {
    if (action === "Simulate") {
      satelliteGroup = filterAssignedSatellites(satelliteGroup, orderAssignments);
      dispatch(setSelectedGroup({}));
      dispatch(setSelectedSatellite({}));
      dispatch(setDefaultPredictionData(scenario));
      dispatch(setAllowPresimAnalyze(true));
      dispatch(
        setDefaultPredictionForSatellite({
          satelliteId: satelliteGroup?.satellites?.[0]?.satelliteId,
          status: "pending",
        })
      );
      checkPredictionData()
    } else {
      dispatch(UnifiedControlPlaneService.getOrders());
      dispatch(UnifiedControlPlaneService.getCurrentSchedule(mission_id));
    }
  };

  const checkDisabled = () => {
    const filteredGroup = filterAssignedSatellites(satelliteGroup, orderAssignments);
    if (
      !filteredGroup ||
      !Array.isArray(filteredGroup?.satellites) ||
      filteredGroup?.satellites?.length === 0
    ) {
      return true;
    }

    return false;
  };


  useEffect(() => {
    if (previewScheduleId) {
      schedules?.forEach((singleSch) => {
        if (singleSch?.scheduleId === previewScheduleId) {
          setCurrentSchedule(singleSch);
        }
      });
    }
  }, [schedules, previewScheduleId]);

  const updateSchedule = (action) => {
    dispatch(
      UnifiedControlPlaneService.updateSchedules(
        mission_id,
        action,
        currentSchedule,
        orderUpdateSuccessCallback
      )
    );
    dispatch(setShowReviewSchedulePopup(""));
  };

  const [data, setData] = useState([]);

  useEffect(() => {
    if (orderAssignments && Array.isArray(orderAssignments)) {
      setData(orderAssignments);
    }
  }, [orderAssignments]);

  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedData = [...data].sort((a, b) => {
      const aValue = getNestedValue(a, key);
      const bValue = getNestedValue(b, key);

      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setData(sortedData);
    setSortConfig({ key, direction });
  };

  const [showSearchPopup, setShowSearchPopup] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const togglePopup = () => setShowSearchPopup((prev) => !prev);
  //const searchInputRef = useRef(null);

  // const saveSearchTerm = () => {
  //   setSearchTerm(searchInputRef.current.value);
  // };

  const SearchPopup = () => (
    <div className="search-popup">
      <div className="search-popup-content">
        <input
          type="text"
          placeholder="Search by Order Name"
          // defaultValue={searchTerm}
          // ref={searchInputRef}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-popup-input"
          autoFocus
        />
        {/* <button onClick={saveSearchTerm}>Search</button> */}
        <div className="current-schedule-close-action" onClick={togglePopup}>
          <img
            className="CloseIcon"
            src={require("../../assets/raw/CloseIconWhite.svg").default}
            alt="close-icon"
          />
        </div>
      </div>
    </div>
  );

  const filteredData = searchTerm
    ? data.filter((row) =>
      row.orderName?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    : data;

  const closeScheduleReview = () => {
    setSearchTerm("");
    setShowSearchPopup(false);
    dispatch(setShowReviewSchedulePopup(""));
  };

  const navigateToListView = () => {
    dispatch(setShowReviewSchedulePopup("list-schedule"));
  };

  const openScheduleDashboard = () => {
    if (currentSchedule?.state !== "Current") {
      updateSchedule("Simulate");
    }
    dispatch(setScheduleDashboardView(true));
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (fidelityConfigRef.current && !fidelityConfigRef.current.contains(e.target) && toggleButtonRef.current && !toggleButtonRef.current.contains(e.target)) {
        setShowFidelityConfig(false);
      }
    }

    if (showFidelityConfig) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    }

  }, [showFidelityConfig])

  const toggleFidelityMode = () => {
    const updatedFidelity = fidelity === 'low' ? 'high' : 'low';
    dispatch(setFidelity(updatedFidelity));
  }

  return (
    <div className={`current-schedule ${fetchingOrderAssignments ? "loading-schedule" : ""}`}>
      {showSearchPopup && <SearchPopup />}
      <div className="current-schedule-header">
        <div className="current-schedule-title">
          <img
            className="GenerateScehduleIcon"
            style={{ cursor: "pointer" }}
            src={require("../../assets/raw/backButton.svg").default}
            alt="back-icon"
            onClick={() => navigateToListView()}
          />
          <p className="current-schedule-title-text current-schedule-title-highlight">
            {currentSchedule?.label}
          </p>
        </div>
        <div className="current-schedule-orders-summary">
          <div
            className="current-schedule-close-action"
            onClick={closeScheduleReview}
          >
            <img
              className="CloseIcon"
              src={require("../../assets/raw/CloseIconWhite.svg").default}
              alt="close-icon"
            />
          </div>
        </div>
      </div>
      {fetchingOrderAssignments ? (
        <div className="loading-schedule-msg">
          <CircularProgress color="inherit" />
        </div>
      ) : filteredData && filteredData.length > 0 ? (
        <Fragment>
          <div className="schedule-table-section">
            <table className="schedule-table">
              <thead className="schedule-table-header">
                <tr className="schedule-table-row">
                  <th className="schedule-table-column-width"></th>
                  <th className="schedule-table-column-width">
                    <span>
                      Assignment
                    </span>
                    <span
                      className="table-sort"
                      onClick={() => handleSort("label")}
                    >
                      <SortColumnIcon />
                    </span>
                  </th>
                  <th className="schedule-table-column-width">
                    Order Details
                    {/* <button
                            className="table-sort"
                            onClick={() => handleSort("orderName")}>
                            <img className="sort-col" src={require("../../assets/raw/SortIcon.svg").default} />
                        </button> */}
                    {/* <button
                            className="table-sort"
                            onClick={togglePopup}>
                            <img className="filter-col" src={require("../../assets/raw/FilterIconWhite.svg").default} />
                        </button> */}
                  </th>
                  <th className="schedule-table-column-width">
                    <span>Time</span>
                    <div
                      className="table-sort"

                      onClick={() => handleSort("startEpochSec")}
                    >
                      <SortColumnIcon />
                    </div>
                  </th>
                  {/* <th className="schedule-table-column-width">
                          Satellite
                          <button
                              className="table-sort"
                              onClick={() => handleSort("data.satellite.name")}>
                              <img className="sort-col" src={require("../../assets/raw/SortIcon.svg").default} />
                          </button>
                      </th> */}
                </tr>
              </thead>
              <tbody className={`schedule-table-content ${currentSchedule?.state === "Draft" || "Experimental" ? "with-actions" : ""}`}>
                {filteredData.map((row, index) => (
                  <tr key={index} className="schedule-table-row">
                    <td className="schedule-table-column-width">
                      <CustomToolTip title={getStatusDetails(row?.state, "Text")}>
                        <div
                          className={`status-icon ${row?.state === "active" ? "rotate-icon" : ""}`}
                        >
                          {getStatusDetails(row?.state, "Icon")}
                        </div>
                      </CustomToolTip>
                    </td>
                    <td className="schedule-table-column schedule-table-column-width assignment-column">
                      <div className="assignment-icon status-icon">
                        {row?.type === "Order" ? (
                          <>
                            <ScheduleOrderAssignIcon />
                            <span className="ucpTooltip-right">Order Task</span>
                          </>
                        ) : (
                          <>
                            <ScheduleGroundAssignIcon />
                            <span className="ucpTooltip-right">Ground Task</span>
                          </>
                        )}
                      </div>
                      {row?.type === "Order" ? (
                        <div className="assignment-group">
                          <span className="satellite-name limit-text">
                            {row?.data?.satellite?.name}
                          </span>
                        </div>
                      ) : (
                        <div className="assignment-group">
                          <span className="satellite-name limit-text">
                            {row?.data?.satellite?.name}
                          </span>
                          <span className="ground-station-name">
                            {row?.data?.groundStation?.name}
                          </span>
                        </div>
                      )}
                    </td>
                    <td className="schedule-table-column schedule-table-column-width">
                      {row?.type === "Order" ? (
                        <div className="order-name-group">
                          <img
                            src={getPriorityIcon(
                              row?.data?.orderSummary?.priorityLane
                            )}
                            alt="order-details-spacing"
                          />
                          <span className="order-name limit-text">
                            {row?.data?.orderSummary?.orderName
                              ? row?.data?.orderSummary?.orderName
                              : "-"}
                          </span>
                        </div>
                      ) : (
                        <div className="orders-wrapper">
                          <CustomToolTip title={getListOfOrders(row?.data?.downlinkOrders)}>
                            <span className="orders_text">
                              <span className="order_details_spacing">
                                {row?.data?.downlinkOrders
                                  ? row?.data?.downlinkOrders.length > 1 ? row?.data?.downlinkOrders.length : getListOfOrders(row?.data?.downlinkOrders)
                                  : "All"}
                              </span>
                              {row?.data?.downlinkOrders.length > 1 ? 'Orders' : ''}
                            </span>
                          </CustomToolTip>
                        </div>
                      )}
                    </td>
                    <td className="time-column schedule-table-column-width">
                      {getTimeEpochToUTC(row?.startEpochSec)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {currentSchedule && (currentSchedule?.state === "Draft" || currentSchedule?.state === "Experimental" || currentSchedule?.state === "Current") && (
            <div className="current-schedule-actions">
              <div className="current-schedule-actions-group">
                <div className="current-schedule-actions-sub-group">
                  <div className="current-schedule-button-group">
                    <button
                      className={`current-schedule-button ps-btn-light ${checkDisabled() ? "disabled" : ""}`}
                      onClick={openScheduleDashboard}
                      disabled={checkDisabled()}
                    >
                      Analyze
                      {!showFidelityConfig && !checkDisabled() && <span className="fidelity-tooltip">Run Analysis on Schedule</span>}
                    </button>
                    <button
                      className={`fidelity-toggle-button ${checkDisabled() ? "disabled" : ""}`}
                      ref={toggleButtonRef}
                      disabled={checkDisabled()}
                      onClick={() => {
                        setShowFidelityConfig(!showFidelityConfig)
                      }}
                    >
                      <ChevronRight className={`fidelity-toggle-icon ${showFidelityConfig ? 'rotated' : ''}`} />
                      {!showFidelityConfig && !checkDisabled() && <span className="fidelity-tooltip">Fidelity Configuration</span>}
                    </button>
                  </div>
                  {/* *** AT-11588 FIX *** */}
                  {/* <button className="current-schedule-button ps-btn-dark">
                    Modify
                  </button> */}
                </div>
                {currentSchedule?.state === "Draft" &&
                  <div className="current-schedule-actions-sub-group">
                    <button
                      className="current-schedule-button ps-btn-dark"
                      onClick={() => updateSchedule("Reject")}
                    >
                      Reject
                    </button>
                    <button
                      className="current-schedule-button ps-btn-light"
                      onClick={() => updateSchedule("Approve")}
                    >
                      Approve
                    </button>
                  </div>
                }
                {showFidelityConfig && (
                  <div className="schedule-fidelity-config-container" ref={fidelityConfigRef}>
                    <div className="schedule-fidelity-config-panel">
                      <div className="fidelity-config-header">
                        <div className="fidelity-config-header-title">
                          Pre-Sim Fidelity
                        </div>
                        <div className={`fidelity-config-header-icon ${showFidelityInfo ? 'active' : ''}`} onClick={() => setShowFidelityInfo(!showFidelityInfo)}
                        >
                          <InfoIcon />
                          {showFidelityConfig && showFidelityInfo &&
                            <div className="fidelity-info-tooltip">
                              <span className="fidelity-info-tooltip-text">
                                Fidelity controls the granularity of simulation results, where low fidelity means quick processing and lesser details whereas high means higher processing and more details.
                              </span>
                            </div>
                          }
                        </div>
                      </div>
                      <div className="fidelity-mode-selector">
                        <div className={`fidelity-mode-option ${fidelity === 'low' ?
                          'active' : ''}`} onClick={toggleFidelityMode} >
                          <div className={`fidelity-mode-text ${fidelity === 'low' ?
                            'active' : ''}`}>
                            Low
                          </div>
                        </div>
                        <div className={`fidelity-mode-option ${fidelity === 'high' ?
                          'active' : ''}`} onClick={toggleFidelityMode}>
                          <div className={`fidelity-mode-text ${fidelity === 'high' ?
                            'active' : ''}`}>
                            High
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </Fragment>
      ) : (
        <div className="empty-schedule-container">
          <EmptyListIcon />
          <div className="empty-schedule-text-container">
            <div className="empty-schedule-text-style empty-schedule-text">
              No order assignments
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SingleScheduleView;
